module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gd-Ha-Ic-Ja.0ef37286.png";